import { startOfMonth } from 'date-fns'
import { IReservationsList, ReservationSortOrder } from './index'

export default {
  canceledReservations: [],
  deletedReservations: [],
  date: startOfMonth(new Date()),
  loading: false,
  newReservations: [],
  search: '',
  sortOrder: 0 as ReservationSortOrder,
} as IReservationsList
